import * as React from 'react'
import { useToast } from 'app/shared/context/CommonUIProvider'
import { Button } from 'primereact/button'
import Icon from 'app/shared/components/Icon'
import Dialog from 'app/shared/components/Dialog'
import { useLocation } from 'react-router-dom'
import { getAppMode, getDeviceType } from 'app/shared/utils/comUtil'
import { useLazySelectCom0102Query } from 'app/core/services/com/com.service'
import { showAlert } from '../utils/util'

/*======================================================================
 * @ 업무설명 : 공유하기
 * @ 파 일 명 : /app/shared/components/Share.tsx
 * @ 화면 ID : SC-COM-2001-P
 * @ 프로그램ID : PR-PRF-158
 * @Rest URI :
 * @ASIS : 신규
 *======================================================================
 * 번호  작업자           작업일         변경내용
 *======================================================================
 * 1     한중근(S27239)   2025.07.08    최초작성
 *======================================================================
 */
type ShareProps = {
    kakaoKey?: string
    shareLink: string
    visible: boolean
    onShare(open: boolean): void
}

const Share: React.FC<ShareProps> = (props) => {
    const location = useLocation()
    const { shareLink, visible, onShare, kakaoKey } = props
    const { show: toastShow } = useToast()
    const showToast = (success: boolean) => {
        toastShow({
            severity: success ? 'success' : 'error',
            content: success
                ? `URL 복사했어요.`
                : 'URL 복사를 실패했어요. 다시 시도해주세요',
        })
    }
    const resultCom0102 = React.useRef(null)
    const [fetchCom0102] = useLazySelectCom0102Query()

    //  sms 공유하기 버튼
    const smsShare = () => {
        let body = ''
        const smsText = `IBK 모바일브랜치\n${shareLink}`

        if (getDeviceType() === 'I') {
            body = '&body=' + encodeURIComponent(smsText)
        } else {
            body =
                '?body=' +
                smsText.replace(/(\n|\r\n)/g, '%0a').replace(/(&)/g, '%2526')
        }

        window.location.href = `sms:${body}` // & 두번 인코딩
    }

    // 클립보드 복사하기 버튼
    const copyToClipboard = () => {
        navigator.clipboard
            .writeText(`${shareLink}`)
            .then(() => showToast(true))
            .catch(() => showToast(false))
    }

    const init = async () => {
        //공통코드 110  그룹ID 'KAKAO', 코드ID 'API_KEY'의 속성2 값을 셋팅함.
        // resultCom0102.current = await fetchCom0102({
        //     dsrnTgtBacd: '110',
        //     cdgpId: 'KAKAO',
        //     ccddId: '',
        // })

        // SDK 초기화
        if (getAppMode() !== 'local' && globalThis.Kakao && kakaoKey) {
            if (!globalThis.Kakao.isInitialized()) {
                globalThis.Kakao?.init(`${kakaoKey}`)
            } else {
                globalThis.Kakao?.cleanup()
                globalThis.Kakao?.init(`${kakaoKey}`)
            }
            // 초기화 확인
        }
    }

    const paths = process.env.REACT_APP_KAKAO_IMG_URL
    // 카카오
    const kakaoShare = () => {
        if (globalThis.Kakao && kakaoKey) {
            globalThis.Kakao.Share.sendDefault({
                objectType: 'feed',
                content: {
                    title: 'IBK 모바일브랜치', // 해당 공유 메뉴 제목
                    // description: '공유할 설명', // 해당 공유 메뉴 설명 추가 하려면 주석 풀기
                    //imageUrl: 'https://example.com/image.jpg',    //  내부망 test용
                    imageUrl: `${paths}/assets/images/common/ibk_share_default_image.png`, // 이미지 URL 외부 https 환경에서 이미지 나와야함
                    link: {
                        mobileWebUrl: `${shareLink}`, // 공유할 URL
                        webUrl: `${shareLink}`, // 공유할 URL
                    },
                },
            })
        } else {
            showAlert({ msg: 'KAKAO SDK NOT IMPORTED' })
        }
    }

    React.useEffect(() => {
        if (kakaoKey) {
            init()
        }
    }, [kakaoKey])

    return (
        <Dialog
            closeFocus=""
            visible={visible}
            header="공유하기"
            className="bottom-sheet bottom-sheet-share"
            onClose={() => onShare(false)}
        >
            <div className="shares">
                <Button className="item" onClick={() => kakaoShare()}>
                    <Icon name="kao" />
                    카카오톡
                </Button>
                <Button className="item" onClick={() => smsShare()}>
                    <Icon name="mss" />
                    문자메시지
                </Button>
                <Button className="item" onClick={() => copyToClipboard()}>
                    <Icon name="link" />
                    URL 복사
                </Button>
            </div>
        </Dialog>
    )
}

export default Share
